import { LiveBrowserRenderer } from './classes.livebrowserrenderer.js';
import type { ILiveBrowserVideoRendererOptions } from './interfaces.livebrowservideo.js';

/** Native video presentation; shares input, viewport and lifecycle handling with the canvas renderer. */
export class LiveBrowserVideoRenderer extends LiveBrowserRenderer {
  constructor(optionsArg: ILiveBrowserVideoRendererOptions) {
    super(optionsArg);
  }
}
